import React, { useMemo, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Collapse,
    Divider
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ScrollableWithGradients from "./ScrollableWithGradients";

 const Section = ({
   id,
   title,
   lessons,
   openSection,
   setOpenSection,
   selectedLesson,
   setSelectedLesson
 }) => {
   const isOpen = openSection === id;

   const groupedByCcy = useMemo(() => {
     const map = {};
     lessons.forEach(l => {
       if (!map[l.ccy]) {
         map[l.ccy] = { lessons: [], totalBalance: 0 };
       }
       map[l.ccy].lessons.push(l);
       map[l.ccy].totalBalance = Number(l.balance || 0);
     });
     return map;
   }, [lessons]);

   if (!lessons.length) return null;

   return (
    // <ScrollableWithGradients>
    <Card sx={{ mb: 2 }}>
       <CardContent
         sx={{ cursor: "pointer" }}
         onClick={() => setOpenSection(isOpen ? null : id)}
       >
         <Box display="flex" justifyContent="space-between">
           <Typography variant="h6">{title}</Typography>
           {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
         </Box>
       </CardContent>

       <Collapse in={isOpen}>
         <Divider />

         <ScrollableWithGradients>
         {Object.entries(groupedByCcy).map(([ccy, group]) => (
           <Box key={ccy} p={2}>
             <Typography variant="subtitle1" sx={{ mb: 1 }}>
               {ccy} - balance: {group.totalBalance}
             </Typography>

             {group.lessons.map(lesson => (
               <Card
                 key={lesson.uid}
                 sx={{
                   mb: 1,
                   cursor: "pointer",
                   bgcolor:
                     selectedLesson?.uid === lesson.uid
                       ? "#d0f0d0"
                       : "white",
                   "&:hover": { bgcolor: "#e6f2ff" }
                 }}
                 onClick={(e) => {
                   e.stopPropagation();
                   setSelectedLesson(lesson);
                 }}
               >
                 <CardContent>
                   <Typography variant="subtitle2">
                     {lesson.name}
                   </Typography>
                   <Typography variant="body2" color="text.secondary">
                     {new Date(lesson.startDttm).toLocaleString()}
                   </Typography>
                   <Typography
                     variant="body2"
                     color={lesson.balance < 0 ? "error" : "success.main"}
                   >
                     Balance: {lesson.balance}
                   </Typography>
                 </CardContent>
               </Card>
             ))}
           </Box>
         ))}
         </ScrollableWithGradients>
       </Collapse>
     </Card>
    //  </ScrollableWithGradients>
   );
 };

 const LessonDebtStack = ({
   pastLessons,
   futureLessons,
   unattendedLessons,
   selectedLesson,
   setSelectedLesson
 }) => {
   const [openSection, setOpenSection] = useState(null);

   return (
     <Box>
       <Section
         id="past"
         title="Past debt lessons"
         lessons={pastLessons}
         openSection={openSection}
         setOpenSection={setOpenSection}
         selectedLesson={selectedLesson}
         setSelectedLesson={setSelectedLesson}
       />

       <Section
         id="future"
         title="Future debt lessons"
         lessons={futureLessons}
         openSection={openSection}
         setOpenSection={setOpenSection}
         selectedLesson={selectedLesson}
         setSelectedLesson={setSelectedLesson}
       />

       <Section
         id="unattended"
         title="Unattended lessons"
         lessons={unattendedLessons}
         openSection={openSection}
         setOpenSection={setOpenSection}
         selectedLesson={selectedLesson}
         setSelectedLesson={setSelectedLesson}
       />
     </Box>
   );
 };

 export default LessonDebtStack;
